import PropTypes from "prop-types"
import classNames from "classnames"
import { TableBody as MUITableBody } from "@mui/material"
import GroupedTableBody from "./components/grouped-table-body"
import TableBody from "./components/table-body"
import FactorsTableBody from "./components/factors-table-body"
import { THRESHOLD_PARAMS } from "helpers/threshold"
import "./style.scss"

function ContributorsDetails({
  selected,
  data,
  openSecurityProfile,
  openFactorProfile,
  openCompositeSecurity,
  openBasket,
  showGroup,
  selectedGroup,
  contributorsGrouping,
  groupedData,
  factors,
  disabled,
  factorTable,
  show,
  decompositionTitle,
  noPercent,
  allFactors,
  drift,
  driftType,
  driftArrows,
  showDriftColumn,
  hideSelectedField,
  enableBasketDrillDown,
  noFactorDrilldown,
  page,
  setPage,
  thresholdParams,
  formatter,
}) {
  if (factors) {
    return (
      <MUITableBody className="components_contributors-table-content">
        <FactorsTableBody {...{
          driftType,
          drift,
          driftArrows,
          showDriftColumn,
          noPercent,
          decompositionTitle,
          disabled,
          openFactorProfile,
          factorTable,
          show,
          data,
          allFactors,
          noFactorDrilldown,
          thresholdParams,
          formatter,
        }}
        />
      </MUITableBody>
    )
  }

  const tableBody = contributorsGrouping ? (
    <GroupedTableBody
      noPercent={noPercent}
      selected={selected}
      openSecurityProfile={openSecurityProfile}
      openFactorProfile={openFactorProfile}
      openBasket={openBasket}
      hideSelectedField={hideSelectedField}
      selectedGroup={selectedGroup}
      showGroup={showGroup}
      groupedData={groupedData}
      enableBasketDrillDown={enableBasketDrillDown}
      page={page}
      setPage={setPage}
      formatter={formatter}
    />
  ) : (
    <TableBody
      data={data}
      noPercent={noPercent}
      selected={selected}
      openSecurityProfile={openSecurityProfile}
      openFactorProfile={openFactorProfile}
      openCompositeSecurity={openCompositeSecurity}
      openBasket={openBasket}
      hideSelectedField={hideSelectedField}
      enableBasketDrillDown={enableBasketDrillDown}
      page={page}
      setPage={setPage}
      formatter={formatter}
    />
  )

  return (
    <MUITableBody
      className={classNames(
        "components_contributors-table-content",
        {
          "grouped-contributors-table-body": !selectedGroup && contributorsGrouping,
        },
      )}
    >
      {tableBody}
    </MUITableBody>
  )
}

ContributorsDetails.propTypes = {
  selected: PropTypes.object,
  data: PropTypes.array.isRequired,
  openSecurityProfile: PropTypes.func,
  openFactorProfile: PropTypes.func,
  openCompositeSecurity: PropTypes.func,
  openBasket: PropTypes.func,
  showGroup: PropTypes.func,
  selectedGroup: PropTypes.object,
  selectedBasket: PropTypes.object,
  contributorsGrouping: PropTypes.object,
  groupedData: PropTypes.array,
  disabled: PropTypes.bool,
  factorTable: PropTypes.bool,
  factors: PropTypes.bool,
  show: PropTypes.func,
  decompositionTitle: PropTypes.string,
  drift: PropTypes.object,
  driftType: PropTypes.string,
  driftArrows: PropTypes.object,
  showDriftColumn: PropTypes.bool,
  noPercent: PropTypes.bool,
  allFactors: PropTypes.bool,
  hideSelectedField: PropTypes.bool,
  enableBasketDrillDown: PropTypes.bool,
  noFactorDrilldown: PropTypes.bool,
  page: PropTypes.number,
  setPage: PropTypes.func,
  thresholdParams: THRESHOLD_PARAMS,
  formatter: PropTypes.func,
}

export default ContributorsDetails
